import { Reveal } from "@/components/Reveal";

const ITEMS = [
    "Level 5 Drywall",
    "Venetian Plaster",
    "Custom Tile & Marble",
    "Hardwood & LVP",
    "Broward County",
    "Palm Beach County",
];

export const Marquee = () => (
    <div className="marquee-band overflow-hidden border-y border-line bg-sand py-6" aria-label="Services marquee">
        <div className="flex w-max animate-marquee">
            {[0, 1].map((copy) => (
                <div
                    key={copy}
                    aria-hidden={copy === 1}
                    className="flex shrink-0 items-center"
                >
                    {ITEMS.map((item) => (
                        <span key={`${copy}-${item}`} className="flex items-center">
                            <span className="px-10 font-mono text-sm font-medium uppercase tracking-[0.3em] text-espresso/80">
                                {item}
                            </span>
                            <span className="h-2 w-2 rotate-45 bg-oak" />
                        </span>
                    ))}
                </div>
            ))}
        </div>
    </div>
);
